import React, {useCallback, useState} from 'react';
import Button from "@mui/material/Button";

import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';

import TextField from "@mui/material/TextField";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import axios from "axios";
import * as yup from 'yup';
import {IconButton, Stack} from "@mui/material";
import {Formik} from 'formik';
import {toast} from "@lb/mlib-components";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import ConfirmModal from "../ui/ConfirmModal";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {getMomentDateFromStringNoYear} from "../../utils/getMomentDateFromString";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    width: 400,
    p: 3,
};

const validationSchema = yup.object({
    holiday: yup.date().required('Holiday is required'),
    title: yup.string('Enter title').min(1, 'Title should be of minimum 1 character long')
        .required('Title is required'),

});

export default function EditHolidayForm(props) {

    const initialValues = {
        title: props.holiday?.title || '',
        holiday: props.holiday?.holiday || '',
    };

    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = React.useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const onConfirm = useCallback(() => {

        return axios.delete('/holidays/' + props.holiday?.holiday)
            .then((response) => {
                toast.success('Your request has been successfully sent.');
            }).finally(() => {
                props.handleClose();
                setOpenConfirmationModal(false)
            })

    }, [props]);


    return (

        <Formik
            initialValues={initialValues} enableReinitialize validationSchema={validationSchema}

            onSubmit={async (values) => {
                setOpenBackdrop(true);


                let data = {
                        title: values.title,
                    }
                ;


                axios.put(`/holidays/${props.holiday?.holiday}`,
                    data).then((res) => {

                    toast.success('Your request has been successfully sent.');

                    props.handleClose();

                }).finally((error) => {
                    setOpenBackdrop(false);

                });


            }}
        >
            {propsFormik => (

                <Box component="form" sx={style} onSubmit={propsFormik.handleSubmit}>
                    <Backdrop
                        sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={openBackdrop}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                    <Box display="flex" alignItems="center">
                        <Box flexGrow={1}>
                            <Typography variant="h5" component="div">
                                Edit {getMomentDateFromStringNoYear({value: props.holiday?.holiday})}
                            </Typography>
                        </Box>
                        <Box>
                            <IconButton onClick={props.handleClose}>
                                <CloseIcon/>
                            </IconButton>
                        </Box>
                    </Box>
                    <hr style={{
                        border: "0",
                        height: "0",
                        borderTop: "1px solid rgba(0, 0, 0, 0.5)",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.3)"
                    }}/>
                    <Box overflow="auto"
                         width="100%"
                         flexDirection="column"
                         display="flex"
                         paddingTop={1}>

                        <Stack spacing={2} direction="row" alignItems={"center"}>

                            <TextField
                                title="title"
                                fullWidth
                                id="title"
                                name="title"
                                label="Title"
                                autoFocus
                                value={propsFormik.values.title}
                                onChange={propsFormik.handleChange}
                                error={propsFormik.touched.title && Boolean(propsFormik.errors.title)}
                                helperText={propsFormik.touched.title && propsFormik.errors.title}
                            />


                        </Stack>

                    </Box>
                    <Stack spacing={2} paddingTop={2} direction="row-reverse">

                        <Button
                            variant="contained"
                            type="submit"
                            aria-label="save"
                            startIcon={<SaveIcon/>}
                        >
                            Save
                        </Button>
                        <Button
                            color="error"
                            variant="outlined"
                            startIcon={<DeleteOutlineIcon/>}
                            onClick={() => {
                                setOpenConfirmationModal(true)
                            }}
                        >
                            Delete
                        </Button>

                        <ConfirmModal open={openConfirmationModal}
                                      mainTitle={'Delete Holiday'}
                                      title="Please confirm the deletion of this holiday."
                                      onClose={() => setOpenConfirmationModal(false)}
                                      onConfirm={onConfirm}
                        />

                    </Stack>
                </Box>
            )}

        </Formik>
    );
}
